/** Причины возврата. Значения совпадают с enum refund_reason в БД
 *  (миграция 0031) и со списком REASONS в backend/src/routes/refunds.ts. */
export const REFUND_REASONS: { value: string; label: string }[] = [
  { value: 'breakup', label: 'Расставание' },
  { value: 'not_relevant', label: 'Не актуально' },
  { value: 'format', label: 'Не подошёл формат' },
  { value: 'deadline', label: 'Не успевает сроки' },
  { value: 'defect', label: 'Брак в книге' },
  { value: 'other', label: 'Другое' },
];

export const REFUND_REASON_LABEL: Record<string, string> = Object.fromEntries(
  REFUND_REASONS.map((r) => [r.value, r.label]),
);

/** Валюты — те же, что поддерживает currencyEnum на бэке. */
export const REFUND_CURRENCIES = [
  'KZT',
  'USD',
  'AZN',
  'BYN',
  'GEL',
  'TRY',
  'RUB',
  'EUR',
  'KGS',
] as const;

export interface RefundRow {
  id: number;
  userId: number;
  username: string | null;
  amount: number | null;
  currency: string;
  paidTotal: number;
  paidByCurrency: Record<string, number>;
  reason: string | null;
  reasonText: string;
  isFull: boolean;
  /** Статус заказа. У частичного возврата — прежний, возврат его не меняет. */
  orderStatus: string | null;
  refundedAt: string | null;
  staffName: string | null;
  purchaseDate: string | null;
  /** Легаси-строка из миграции 0031: сумму и причину надо дозаполнить. */
  needsInfo: boolean;
}

export const fmtAmount = (v: number | null | undefined): string =>
  v === null || v === undefined ? '—' : v.toLocaleString('ru-RU');

/** Подпись причины с расшифровкой для «другое». */
export const reasonLabel = (
  reason: string | null,
  reasonText: string | null | undefined,
): string => {
  if (!reason) return '—';
  const base = REFUND_REASON_LABEL[reason] || reason;
  if (reason === 'other' && reasonText) return `${base}: ${reasonText}`;
  return base;
};
